import { KitType } from '@repo/types';
import useFeature from 'services/features/useFeature';
import useCurrentKitAndTinyAccount from './useCurrentKitAndTinyAccount';

// Gut body connections is stool-only; vaginal kits stay on the legacy section
// even when the redesigned condition detail page is on for them.
export const useGutBodyConnections = (): boolean => {
  const { isFeatureEnabled } = useFeature('gut_x_axis');
  const { currentKitType } = useCurrentKitAndTinyAccount();

  return isFeatureEnabled && currentKitType === KitType.STOOL;
};

export default useGutBodyConnections;
